export default "__VITE_ASSET__BmZRy0Eb__"